import { arrayPushUnique } from '../../../../core/util/array-push-unique';
import { isInArray } from '../../../../core/util/is-in-array';
import { Form } from '../../../../vas/business-objects/form/form.model';
import { Group } from '../../../../vas/business-objects/group/group.model';
import * as actions from '../form-manager-page.actions';
import { initialState, State } from '../form-manager-page.reducer';

export const groupCreateReducer = (
    state = initialState,
    action: actions.GroupCreate
): State => {
    if (
        state.group.ids.find(id => id === action.payload.group.id)
    ) {
        return state;
    }

    const group = new Group({
        ...action.payload.group,
        forms: arrayPushUnique(
            action.payload.group.forms,
            state.form.selected
        )
    });

    const dirtyFormIds = state.form.ids
        .filter(id => isInArray(id, group.forms));

    return {
        ...state,
        dirty: true,
        dirtyIds: {
            ...state.dirtyIds,
            forms: dirtyFormIds.reduce(
                (acc, id) => arrayPushUnique(acc, id),
                state.dirtyIds.forms
            ),
            groups: arrayPushUnique(state.dirtyIds.groups, group.id)
        },
        form: {
            ...state.form,
            entities: state.form.ids
                .map(id => state.form.entities[id])
                .map(form => {
                    if (!isInArray(form.id, group.forms)) {
                        return form;
                    }

                    return new Form({
                        ...form,
                        groups: arrayPushUnique(
                            form.groups,
                            group.id
                        )
                    });
                })
                .reduce((p, c) => {
                    p[c.id] = c;
                    return p;
                }, {})
        },
        group: {
            ...state.group,
            ids: [...state.group.ids, action.payload.group.id],
            entities: {
                ...state.group.entities,
                [action.payload.group.id]: group
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/reducers/group-create.reducer.ts